import { c as _c } from "react/compiler-runtime";
import type { Column, ColumnDataType } from '../core';
interface FilterSubjectProps<TData, TType extends ColumnDataType> {
  column: Column<TData, TType>;
}
export function FilterSubject(t0) {
  const $ = _c(2);
  const {
    column
  } = t0;
  let t1;
  if ($[0] !== column.displayName) {
    t1 = <span className="flex items-center px-2 font-medium whitespace-nowrap select-none" data-sentry-component="FilterSubject" data-sentry-source-file="filter-subject.tsx">{column.displayName}</span>;
    $[0] = column.displayName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}